import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/tDeliveryRest/list',
    method: 'post',
    data,
  })
}

export function getProductList(data) {
  return request({
    url: '/api/tDeliveryRest/listAll',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/tDeliveryRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/tDeliveryRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/tDeliveryRest/' + data,
    method: 'delete',
  })
}
